import React from 'react';
import {Trans} from '@lingui/react';

import Plus from 'shared/ui/icons/Plus';
import Button from 'shared/ui/Button/Button/Button';
import useIsWideScreen from 'shared/lib/hooks/useIsWideScreen';
import {isTranslate} from 'shared/lib/lang';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import styles from './AddMonitorButton.module.scss';

interface AddMonitorButtonProps {
    onClick: () => void;
    mobile?: boolean;
}

const AddMonitorButton: React.FC<AddMonitorButtonProps> = ({ onClick, mobile = false }) => {
    const isWideScreen = useIsWideScreen();
    const label = isTranslate() ? 'Add monitor' : 'Добавить монитор';
    const handleClick = () => {
        onClick();
        reachGoal(YM_GOALS.ADD_MONITOR);
    };

    return (
        <>
            {mobile ? (
                <Button
                    variant="gradient"
                    onClick={handleClick}
                    className={styles.buttonMobile}
                    aria-label={label}
                >
                    <Plus width={45} height={45} />
                    <Trans id="button.add.monitor" message="Добавить монитор" />
                </Button>
            ) : !isWideScreen ? (
                <div className={styles.contentButton}>
                    <Button
                        variant="gradient"
                        onClick={handleClick}
                        className={styles.buttonDesktop}
                    >
                        <Plus width={38} height={38} />
                        <Trans id="button.add.monitor" message="Добавить монитор" />
                    </Button>
                </div>
            ) : (
                <Button
                    variant="gradient"
                    onClick={handleClick}
                    className={styles.buttonTable}
                    aria-label={label}
                >
                    <Plus width={45} height={45} />
                </Button>
            )}
        </>
    );
};

export default AddMonitorButton;